export interface Address {
  street_number?: string;
  route?: string;
  locality?: string;
  state?: string;
  postal_code?: string;
  country?: string;
  country_code?: string;
}

export interface EmployerData {
  id?: number;
  payeReferenceNumber?: string;
  accountsOfficeNumber?: string;
  gatewayCredentialsNumber?: string;
  gatewayCredentialsPassword?: string;
  payeGatewayAuthorizationCode?: string;
  address?: Address;
}

export interface EmployerResponse {
  employer: EmployerData;
}

export const DEFAULT_EMPLOYER_ADDRESS = {
  raw: "First Floor, 244 Edgware Road, Greater London, W2 1DS, GB",
  street_number: "244",
  route: "Edgware Road",
  locality: "Greater London",
  postal_code: "W2 1DS",
  country_code: "GB",
  country: "United Kingdom",
} as const;
